export default __webpack_public_path__ + "static/media/expand_black_arrow.32feab00.svg";